import { FC } from 'react';

import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';
import { useHighflyerStateSlice } from '../../../../store/slices/highflyerState/selectors';
import { SingleMultiplier } from '../../../tableSheet/singleMultiplier/SingleMultiplier';

import { CashedBets } from './CashedBets';
import { TotalBets } from './TotalBets';

import styles from './CashedAndTotalBets.module.css';

interface CashedBetsProps {
  show: boolean;
}

export const CashedAndTotalBets: FC<CashedBetsProps> = ({ show }) => {
  const mul = useHighflyerStateSlice.getMultiplier();

  const leaderBoardHistory = useHighflyerGameStateSlice.leaderBoardHistory();
  const lastGameData = useHighflyerGameStateSlice.lastGameData();

  const mods = useModifiers(styles, 'cashedAndTotalBets_previous', {
    container: !show,
  });

  return (
    <div className={`${styles.cashedAndTotalBets_container} ${mods}`}>
      {!show && (
        <div className={styles.cashedAndTotalBets_multiplier}>
          <SingleMultiplier value={Number(lastGameData?.multiplier)} />
        </div>
      )}
      <div className={styles.cashedAndTotalBets_inner_container}>
        {mul || !show ? (
          <CashedBets
            betCount={show ? leaderBoardHistory?.betCount : lastGameData?.totalBetCount}
            cashedAmount={show ? leaderBoardHistory?.cashedAmount : lastGameData?.totalCashedAmount}
            cashedBetCount={show ? leaderBoardHistory?.cashedBetCount : lastGameData?.totalCashedBetCount}
          />
        ) : (
          <TotalBets betCount={leaderBoardHistory?.betCount} betAmount={leaderBoardHistory?.betAmount} />
        )}
      </div>
    </div>
  );
};
